import { buildEvent } from './utils';
import { IBenefitsCard } from './benefits-refactor.interface';

import { CARD_APPLICATION_STATUS } from '@app/admin/fleet-card/main.constants';

export const DEFAULT_SPEND_MULTIPLIER: number = 100000000;
export const DEFAULT_PROMO_MULTIPLIER: number = 25000000;
export const CFS_10: number = 10;

export const APPROVED_FOOTER_BENEFITS_CARDS: IBenefitsCard[] = [
  {
    icon: '/fleet-cards/approved/base/shield.svg',
    title: $localize`MasterRental Insurance`,
    description: $localize`Added coverage on car rentals such as theft/damage protection and reduced towing charges.`,
  },
  {
    icon: '/fleet-cards/approved/base/clock.svg',
    title: $localize`Extended Warranty`,
    description: $localize`The original manufacturer warranty on most items you purchase is doubled for up to 12 months.`,
  },
  {
    icon: '/fleet-cards/approved/base/check-circle.svg',
    title: $localize`Purchase Assurance`,
    description: $localize`Protects against theft or damage on eligible purchases for 90 days from the date of purchase.`,
  },
  {
    icon: '/fleet-cards/approved/base/card.svg',
    title: $localize`Master Assist`,
    description: $localize`Get around-the-clock protection while traveling, \
    including emergency medical assistance and legal aid.`,
  },
];

export const BENEFITS_EXCLUSION_SET: string[] = [
  'Obtenez 10% de vos frais de matériel et de logiciels Motive sous forme de récompenses Motive Card',
  'Get 10% of your Motive hardware and software fees back as Motive Card Rewards',
];

export const PARTNER_DETAILS = {
  'bridgehaul':  {
    description: 'BridgeHaul Fleet Card',
    altText: 'BridgeHaul Fleet Card',
    bottomImage: '/fleet-cards/approved/bridgehaul/bridgehaul-card-bottom.svg',
    heroBannerImage: '/fleet-cards/approved/bridgehaul/bridgehaul-card-front.svg',
    cardFront: '/fleet-cards/preapproved/bridgehaul/bridgehaul-card.svg',
  },
  'motive': {
    description: 'Motive Card',
    altText: 'Motive Card',
    bottomImage: '/fleet-cards/approved/base/fleet-card-bottom.svg',
    heroBannerImage: '/fleet-cards/approved/base/fleet-card-front.svg',
    cardFront: '/fleet-cards/preapproved/base/motive-card.jpg',
  },
};

export enum ButtonType {
  ApplyNow = 'applyNow',
  CompleteMyApplication = 'completeMyApplication',
  UpdateApplication = 'updateApplication',
  PreviousApplication = 'previousApplication',
  ImInterested = 'imInterested',
  ExplorePotentialSavings = 'explorePotentialSavings',
  GetPdf = 'getPdf',
  SpeakToSavingsExpert = 'speakToSavingsExpert',
  ContactSales = 'contactSales',
  SavingsCalculatorApplyNow = 'savingsCalculatorApplyNow',
  SavingsCalculatorGetPersonalizedAnalysis = 'savingsCalculatorGetPersonalizedAnalysis',
}

export const benefitsButtonText = {
  [ButtonType.ApplyNow]: $localize`Apply now`,
  [ButtonType.CompleteMyApplication]: $localize`Complete my application`,
  [ButtonType.UpdateApplication]: $localize`Update application`,
  [ButtonType.PreviousApplication]: $localize`Previous application`,
  [ButtonType.ImInterested]: $localize`I'm interested`,
  [ButtonType.ExplorePotentialSavings]: $localize`Explore potential savings`,
  [ButtonType.GetPdf]: $localize`Get full analysis (PDF)`,
  [ButtonType.SpeakToSavingsExpert]: $localize`Speak to a savings expert`,
  [ButtonType.ContactSales]: $localize`Contact sales`,
  [ButtonType.SavingsCalculatorApplyNow]: $localize`Apply now`,
  [ButtonType.SavingsCalculatorGetPersonalizedAnalysis]: $localize`Get your personalized analysis`,

  // Application Status Mapping
  [CARD_APPLICATION_STATUS.draft]: $localize`Complete my application`,
  [CARD_APPLICATION_STATUS.needs_verification]: $localize`View application status`,
  [CARD_APPLICATION_STATUS.submitted]: $localize`View application status`,
  [CARD_APPLICATION_STATUS.credit_started]: $localize`View application status`,
  [CARD_APPLICATION_STATUS.credit_declined]: $localize`View previous application`,
  [CARD_APPLICATION_STATUS.kyb_pending]: $localize`View application status`,
};

export const POST_APPLICATION_SUBMISSION_STATUSES: CARD_APPLICATION_STATUS[] = [
  CARD_APPLICATION_STATUS.needs_verification,
  CARD_APPLICATION_STATUS.submitted,
  CARD_APPLICATION_STATUS.credit_started,
  CARD_APPLICATION_STATUS.credit_declined,
  CARD_APPLICATION_STATUS.kyb_pending,
];

export const BENEFITS_PAGE_EVENTS = {
  FAQS: {
    HOW_DO_I_APPLY: buildEvent('FAQs', 'How do I apply'),
    WHAT_DO_I_NEED_TO_APPLY: buildEvent('FAQs', 'What do I need to apply'),
    HOW_MOTIVE_CARD_WORKS: buildEvent('FAQs', 'How Motive Card work'),
  },
  CTA: {
    PAGE_HEADER: buildEvent('Page Header', 'Apply Now'),
    UPSELL_BANNER_APPLY: buildEvent('Upsell Banner', 'Apply Now'),
    UPSELL_BANNER_SAVINGS_EXPLORE: buildEvent('Upsell Banner', 'Explore Potential Savings'),
    UPSELL_BANNER_SAVINGS_INTERESTED: buildEvent('Upsell Banner', "I'm Interested"),
    HERO_HEADER_CAROUSEL: buildEvent('Hero Header Carousel', 'Apply Now'),
    DISCOUNT_PARTNERS: buildEvent('Discount Partners', 'Apply Now'),
    ESTIMATED_SAVINGS_APPLY_IN_MINS: buildEvent('Estimated Savings'),
    SAVINGS_DRAWER_APPLY: buildEvent('Savings Drawer', 'Apply Now'),
    SAVINGS_DRAWER_PDF: buildEvent('Savings Drawer', 'Savings PDF'),
    SAVINGS_CALCULATOR_APPLY_NOW: buildEvent('Savings Calculator', 'Apply Now'),
    SAVINGS_CALCULATOR_GET_PERSONALIZED_ANALYSIS: buildEvent('Savings Calculator', 'Get Personalized Analysis'),
    SAVINGS_CALCULATOR_SHARE_EMAIL_OR_DOWNLOAD: buildEvent('Savings Calculator', 'Share calculator results'),
    SAVINGS_CALCULATOR_CALCULATE: buildEvent('Savings Calculator', 'Calculate Savings'),
  },
};

export const BENEFITS_XL_DESKTOP_BREAKPOINT = 1500; // This is for pre-approved layout only.

// For pre-approved feature sections
export enum FeatureSectionType {
  Benefits = 'benefits',
  Fraud = 'fraud',
}

export enum HeroSlideVariation {
  LeftAligned = 'left-aligned',
  CenterAligned = 'center-aligned',
}

export const LOCATION_COUNT = '35,000';